import { ErrorBoundary } from '@sentry/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedRadarTemplateAtom, setRadarTemplateRenameAtom } from '@/atoms/radar';
import { MenuItemWithIcon } from '@/components/menu/MenuItemWithIcon';
import { hasEditPermissions } from '@/utils/userConfigs';

const RadarTemplateRenameMenuOptionBase = ({ isDisabled, onClick }: { isDisabled?: boolean; onClick?: () => void }) => {
  const { t } = useTranslation(['general', 'entity']);

  return <MenuItemWithIcon icon="Rename" onClick={onClick} text={t('rename')} disabled={isDisabled} />;
};

const RadarTemplateRenameMenuOptionWithData = () => {
  const selectedTemplate = useAtomValue(selectedRadarTemplateAtom);
  const setRadarTemplateRename = useSetAtom(setRadarTemplateRenameAtom);

  if (!selectedTemplate) {
    throw new Error('Unable to find selected radar template');
  }

  return (
    <RadarTemplateRenameMenuOptionBase
      isDisabled={!hasEditPermissions(selectedTemplate.permission)}
      onClick={() => setRadarTemplateRename(selectedTemplate)}
    />
  );
};

export const RadarTemplateRenameMenuOption = () => (
  <ErrorBoundary fallback={<RadarTemplateRenameMenuOptionBase isDisabled />}>
    <Suspense fallback={<RadarTemplateRenameMenuOptionBase isDisabled />}>
      <RadarTemplateRenameMenuOptionWithData />
    </Suspense>
  </ErrorBoundary>
);
